const FILE_PATH = 'top/conf/parts.json';



export default {
  namespaced: true,

  state: {
    loaded: false,
    data: {
      student: [],
      teacher: [],
    },
  },

  getters: {
    filepath: (state, getters, rootState, rootGetters) => rootGetters['path/$join']('resources', FILE_PATH),
    orders: (state, getters, rootState, rootGetters) => {
      const userCategory = rootGetters['segments/user/category'];
      return userCategory && state[userCategory]
    },
  },

  actions: {
    async load({ commit, getters }) {
      const res = await $http.get(getters['filepath']);
      commit('setData', res.data);
    },
  },

  mutations: {
    setData(state, json) {
      Vue.set(state, 'student', json.student);
      Vue.set(state, 'teacher', json.teacher);
      state.loaded = true;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/top/store/parts.js